
import { ObjectField } from 'react3l-decorators';
import nameof from 'ts-nameof.macro';
import { ExternalService } from 'models/ExternalService';
import { ExternalServiceApi } from './ExternalServiceApi';

ObjectField(ExternalService)(ExternalServiceApi.prototype, nameof(ExternalServiceApi.prototype.externalService));

export * from './ExternalServiceApi';
